"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _RedPacketTablePane = _interopRequireDefault(require("./components/RedPacketTablePane.vue"));
var _RedPacketCreatePane = _interopRequireDefault(require("./components/RedPacketCreatePane.vue"));
var _RedPacketUpdatePane = _interopRequireDefault(require("./components/RedPacketUpdatePane.vue"));
var _RedPacketStatisticsPane = _interopRequireDefault(require("./components/RedPacketStatisticsPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RedPacket',
  components: {
    RedPacketTablePane: _RedPacketTablePane.default,
    RedPacketCreatePane: _RedPacketCreatePane.default,
    RedPacketUpdatePane: _RedPacketUpdatePane.default,
    RedPacketStatisticsPane: _RedPacketStatisticsPane.default
  },
  props: {},
  data: function data() {
    return {
      activeName: 'list',
      redPacketId: '',
      redPacketActivityName: ''
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    handleEdit: function handleEdit(id) {
      this.activeName = 'update';
      this.redPacketId = id;
    },
    handleToCreate: function handleToCreate() {
      this.redPacketId = '';
      this.activeName = 'create';
    },
    handleToTable: function handleToTable() {
      this.redPacketId = '';
      this.activeName = 'list';
    },
    handleStatistics: function handleStatistics(id, title) {
      this.activeName = 'statistics';
      this.redPacketId = id;
      this.redPacketActivityName = title;
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'list') {
        this.redPacketId = '';
        this.redPacketActivityName = '';
      }
    },
    handleCopyToCreate: function handleCopyToCreate(id) {
      this.activeName = 'create';
      this.redPacketId = id;
    }
  }
};